import { EnrichmentPlugin, Event } from '@amplitude/analytics-types';

import { AmplitudeAutoTrackEvents } from '@/components/Analytics/amplitude.types';
import { AmplitudePageName, getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

/**
 * Adds Page Name to autocapture page views on article and collection routes.
 * Registered before amplitude.init so it is on the timeline before the first page view fires.
 */
const TAGGED_PAGE_NAMES = [AmplitudePageName.Article, AmplitudePageName.Collections];

export class ArticlePagePropertiesPlugin implements EnrichmentPlugin {
    name = 'article-page-properties-plugin';
    type = 'enrichment' as const;

    execute = async (event: Event) => {
        const autoTrackUrl = event.event_properties?.['[Amplitude] Page URL'];
        if (event.event_type !== AmplitudeAutoTrackEvents.PageViewed || typeof autoTrackUrl !== 'string') {
            return event;
        }

        const pageName = getAmplitudePageNameFromPath(autoTrackUrl);
        if (TAGGED_PAGE_NAMES.includes(pageName)) {
            event.event_properties['Page Name'] = pageName;
        }

        return event;
    };
}
